module.exports = __webpack_public_path__ + "static/img/page7_img0.c4bfb4e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/page7_img0.jpg
// module id = n2Ji
// module chunks = 1